/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
'use client';

import { useParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';

import { doTranslation } from '@/app/i18n/client';
import ButtonTertiary from '@/components/global/buttons/button-tertiary';
import Modal from '@/components/global/modal/modal';
import dynamic from 'next/dynamic';
const Tooltip = dynamic(() => import('@/components/global/tooltip/tooltip'), {
  ssr: false
});
import RatingStars from '@/components/schedule-results/rating-stars';
import { CarrierImage } from '@/utils/carriers';
import { StrapiCarrier, getCarrierReviews } from '@/apis/strapi';

import styles from '@/components/schedule-results/carrier-review.module.scss';

const CarrierReviewDetails = dynamic(() => import('@/components/schedule-results/carrier-review-details'), {
  ssr: false
});

type Props = {
  activeIndex: number | null;
  index: number;
  place: string;
  carrier: StrapiCarrier;
  carrierImages: { [key: string]: CarrierImage };
  tripDetails: boolean;
};

const CarrierReview = (props: Props): React.JSX.Element => {
  const { lng }: any = useParams();

  const { t } = doTranslation(lng);
  const [modal, setModal] = useState<boolean>(false);
  const [carrierReview, setCarrierReview] = useState<any>(null);

  const onCloseReviewDetails = () => {
    setModal(false);
    setCarrierReview(null);
  };

  return (
    <ButtonTertiary
      dark
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          setModal(true);
          setCarrierReview(props.carrier);
        }
      }}
      tabIndex={props.activeIndex === props.index ? 0 : -1}
    >
      <Tooltip
        content={t('View Rating Details')}
        hover={true}
        id={`${props.tripDetails ? 'trip-details' : 'card'}-tooltip-${props.index}`}
        place={props.place}
        tabIndex={-1}
        wrap={false}
      >
        <div
          className={styles.reviews}
          role="region"
          onClick={() => {
            setModal(true);
            setCarrierReview(props.carrier);
          }}
        >
          <div className={styles.rating}>
            {props.carrier.attributes.aggregate_rating && (
              <span aria-hidden="true" className={styles.text}>
                {props.carrier.attributes.aggregate_rating.toFixed(1)}
              </span>
            )}
            <RatingStars
              score={props.carrier.attributes.aggregate_rating || 0}
              hasRatings={props.carrier.attributes.rating_count > 0}
            />
            <span
              aria-label={t('{{ totalRatings }} Reviews', {
                totalRatings: props.carrier.attributes.review_count
              })}
              aria-hidden="true"
              className={styles.text}
            >
              ({props.carrier.attributes.rating_count > 0 ? props.carrier.attributes.rating_count : 0})
            </span>
          </div>
        </div>
      </Tooltip>
      <Modal
        title={props.carrier.attributes.carrier_name}
        isOpen={carrierReview !== null}
        onClose={onCloseReviewDetails}
        carrier={props.carrier}
        carrierImages={props.carrierImages}
        size="small"
      >
        <CarrierReviewDetails carrier={props.carrier} onClose={onCloseReviewDetails} />
      </Modal>
    </ButtonTertiary>
  );
};

export default CarrierReview;
